import { useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api"
import { triggerToDto, TriggerDtoSchema, triggerFromDto } from "@/models/trigger"
import type { Trigger, TriggerDto } from "@/models/trigger"

export function useUpdateTrigger({ onSuccess }: { onSuccess?: () => void } = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (trigger: Trigger) => {
      const dto = triggerToDto(trigger)
      const response = await api.put("/api/triggers", dto, TriggerDtoSchema)
      return triggerFromDto(response as TriggerDto)
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["triggers"] })
      queryClient.invalidateQueries({ queryKey: ["triggers", variables.id] })
      if (onSuccess) onSuccess()
    },
    onError: (error) => {
      console.error("Error updating trigger:", error)
    },
  })
}
